import { motion } from "framer-motion";

const COLS = [
  {
    label: "NEW",
    accent: "#52525B",
    stage: "00",
    deals: [{ v: "$22K",  d: "2d", c: "Acme"     }, { v: "$85K", d: "1d", c: "Plexus"   }],
  },
  {
    label: "QFD",
    accent: "#007AFF",
    stage: "01",
    deals: [{ v: "$140K", d: "4d", c: "Nodal"    }, { v: "$67K", d: "2d", c: "Orbit"    }],
  },
  {
    label: "DEMO",
    accent: "#FFB800",
    stage: "02",
    deals: [
      { v: "$220K", d: "6d", c: "Kairos", hot: true },
      { v: "$95K",  d: "3d", c: "Relay" },
    ],
    stalled: { v: "$44K", d: "14d", c: "Vortex" },
  },
  {
    label: "WON",
    accent: "#CCFF00",
    stage: "03",
    deals: [
      { v: "$310K", c: "Helix",  won: true },
      { v: "$178K", c: "Atlas",  won: true },
    ],
  },
];

export default function PipelineOpsVisual() {
  return (
    <div className="w-full h-full flex flex-col justify-center font-mono" data-testid="pipeline-ops-visual">
      <div className="flex items-center justify-between mb-3 pb-2 border-b border-white/10 text-[10px]">
        <span className="uppercase tracking-[0.3em] text-zinc-500">// pipeline.kanban</span>
        <span className="flex items-center gap-2 text-[#CCFF00]">
          <span className="h-1.5 w-1.5 rounded-full bg-[#CCFF00] animate-pulse" />
          auto-advance
        </span>
      </div>

      <div className="grid grid-cols-4 gap-2">
        {COLS.map((col, ci) => (
          <div key={col.label} className="relative">
            <div className="flex items-center justify-between mb-2.5">
              <span className="flex items-center gap-2">
                <span className="h-2 w-2" style={{ background: col.accent, boxShadow: `0 0 8px ${col.accent}` }} />
                <span className="uppercase tracking-[0.2em] text-white font-bold text-[11px]">
                  {col.label}
                </span>
              </span>
              <span className="text-zinc-600 text-[9px]">{col.stage}</span>
            </div>
            <div className="space-y-2">
              {col.deals.map((deal, di) => (
                <motion.div
                  key={`${col.label}-${di}`}
                  initial={{ opacity: 0, y: 6 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ delay: ci * 0.08 + di * 0.05 }}
                  className="border border-white/10 p-2.5 bg-white/[0.02] relative"
                  style={
                    deal.hot
                      ? { borderColor: "#FFB80066", background: "rgba(255,184,0,0.04)" }
                      : deal.won
                      ? { borderColor: "#CCFF0066", background: "rgba(204,255,0,0.06)" }
                      : {}
                  }
                >
                  <div className="flex items-center justify-between mb-1">
                    <span className="text-white font-bold text-[11px] tabular-nums">{deal.v}</span>
                    {deal.d && <span className="text-zinc-500 text-[9px]">{deal.d}</span>}
                    {deal.won && <span className="text-[#CCFF00] text-[11px]">✓</span>}
                  </div>
                  <div className="text-zinc-400 text-[9px] truncate uppercase tracking-wider">
                    {deal.c}
                  </div>
                  {deal.hot && (
                    <span className="absolute -top-1 -right-1 h-2 w-2 bg-[#FFB800] rounded-full shadow-[0_0_8px_#FFB800] animate-pulse" />
                  )}
                </motion.div>
              ))}
              {col.stalled && (
                <div
                  className="border border-dashed p-2.5 text-[#FF7B5B]"
                  style={{ borderColor: "#FF7B5B66", background: "rgba(255,123,91,0.04)" }}
                >
                  <div className="flex items-center justify-between">
                    <span className="tabular-nums text-[11px] font-bold">{col.stalled.v}</span>
                    <span className="text-[9px]">⚠ {col.stalled.d}</span>
                  </div>
                  <div className="text-[9px] uppercase tracking-wider opacity-70 mt-1">
                    {col.stalled.c}
                  </div>
                </div>
              )}
            </div>
          </div>
        ))}
      </div>

      <div className="mt-4 pt-3 border-t border-dashed border-white/10">
        <div className="flex items-center justify-between text-[10px] uppercase tracking-[0.2em]">
          <span className="text-zinc-500">advances on condition</span>
          <div className="flex items-center gap-1">
            {[0, 1, 2, 3, 4, 5].map((i) => (
              <motion.span
                key={i}
                initial={{ opacity: 0.2 }}
                animate={{ opacity: [0.2, 1, 0.4] }}
                transition={{ duration: 1.4, repeat: Infinity, delay: i * 0.12 }}
                className="h-1.5 w-3"
                style={{ background: "#CCFF00", boxShadow: "0 0 4px #CCFF00" }}
              />
            ))}
          </div>
          <span className="text-[#CCFF00]">$735K pipeline</span>
        </div>
      </div>
    </div>
  );
}
